import { SettingsOutlined } from "@mui/icons-material";
import { Box, Link, Stack, useTheme } from "@mui/material";
import logoSrc from "assets/images/achau_logo.jpeg";
import { RolePermission, UserPermission } from "commons/enum/permission";
import { useCheckPermission } from "commons/hooks/use-check-permission";
import { CommonTransKey } from "localization/translation-key/common";
import { observer } from "mobx-react-lite";
import { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useMatch, useNavigate, useResolvedPath } from "react-router-dom";
import { useStores } from "../../../mobx-stores/_root-store";
import { ImageSkeleton } from "../../../share-components/atomics/image-skeleton";
import { XButton } from "../../../share-components/mui-wrap/button/x-button";
import { XMenu } from "../../../share-components/mui-wrap/x-menu";
import { ProfileAvatar } from "../profile/avatar";
import { ProfileMenuContent } from "../profile/profile-menu-content";
export const Header = observer(() => {
  const theme = useTheme();
  const navigate = useNavigate();
  let resolved = useResolvedPath("/setting/*");
  const { allowAccess } = useCheckPermission([
    UserPermission.Access,
    RolePermission.Access,
  ]);
  const { t } = useTranslation();
  const match = useMatch({ path: resolved.pathname, end: true });
  const [profileAnchorEl, setProfileAnchorEl] = useState<null | HTMLElement>(
    null
  );

  const { setProp } = useStores();
  const openProfileMenu = Boolean(profileAnchorEl);
  const handleProfileClicked = (event: React.MouseEvent<HTMLElement>) => {
    setProfileAnchorEl(event.currentTarget);
  };

  const handleCloseProfileMenu = useCallback(() => {
    setProfileAnchorEl(null);
  }, []);

  useEffect(() => {
    if (match) {
      setProp("mainNavigationMinimize", true);
    }
  }, [match, setProp]);

  const onSettingClicked = useCallback(() => {
    setProp("mainNavigationMinimize", true);
    navigate("setting");
  }, [navigate, setProp]);

  const companyInfoClick = useCallback(() => {
    window.location.replace("/");
  }, []);

  return (
    <Stack
      component={"header"}
      direction={"row"}
      justifyContent={"space-between"}
      alignItems={"center"}
      sx={{ height: "54px", padding: "8px 12px" }}
    >
      <Stack
        direction={"row"}
        spacing={2}
        alignItems={"center"}
        sx={{
          cursor: "pointer",
        }}
        onClick={companyInfoClick}
      >
        <Box id="logo-company">
          <ImageSkeleton src={logoSrc} alt="logo" width={150}></ImageSkeleton>
        </Box>
        {/* <Box id="app-name">
          <Typography
            sx={{ fontSize: "16px" }}
            fontWeight={theme.typography.fontWeightRegular}
          >
            BAO BÌ Á CHÂU
          </Typography>
        </Box> */}
      </Stack>

      <Stack direction={"row"} spacing={2} alignItems={"center"}>
        <Link
          target="_blank"
          href="https://baobiachau.vn/"
          underline="none"
          rel="noopener noreferrer"
          sx={{ display: "inline-flex", alignItems: "center" }}
          aria-label="Trang Web"
          title="Trang Web"
        >
          <Box
            component="img"
            src="/images/bbac-logo.svg"
            alt="BBAC"
            sx={{ height: 30 }}
          />
        </Link>
        <Box onClick={handleProfileClicked}>
          <ProfileAvatar
            sx={{ width: 30, height: 30, cursor: "pointer" }}
          ></ProfileAvatar>
        </Box>

        {allowAccess && (
          <Box>
            <XButton
              LinkComponent="a"
              onClick={onSettingClicked}
              endIcon={<SettingsOutlined></SettingsOutlined>}
              sx={{
                backgroundColor: match
                  ? theme.palette.secondary.main
                  : "#E2E1EC",
                paddingLeft: "15px",
                paddingRight: "15px",
                color: "#454754",
                textTransform: "capitalize",
              }}
            >
              {t(CommonTransKey.setting)}
            </XButton>
          </Box>
        )}
      </Stack>

      <XMenu
        anchorEl={profileAnchorEl}
        open={openProfileMenu}
        sx={{
          ".MuiPaper-root": {
            marginTop: "10px",
          },
        }}
        MenuListProps={{
          sx: {
            width: "350px",
            padding: "16px",
          },
        }}
        onClose={handleCloseProfileMenu}
      >
        <ProfileMenuContent
          onChangePwHandler={() => handleCloseProfileMenu()}
        ></ProfileMenuContent>
      </XMenu>
    </Stack>
  );
});
